export default "__VITE_ASSET__C1cCW2uq__"